import React, {
	forwardRef,
	memo
} from 'react';
import PropTypes from 'prop-types';

import { log } from '../../../services/utils';

import styles from './text-button.module.css';

const TextButton = forwardRef( (
	{
		buttonText,
		className,
		...props
	},
	ref
) => {
	return (
		<>
			{ log( '- textButton' ) }
			<button
				className={ `${ styles.textButton } ${ className }` }
				ref={ ref }
				{ ...props }
			>
				{ buttonText }
			</button>
		</>
	);
} );

TextButton.displayName = 'TextButton';

TextButton.propTypes = {
	buttonText: PropTypes.node.isRequired,
	className: PropTypes.string
};

export default memo( TextButton );
